import { Controller } from 'stimulus';

export default class extends Controller {
  get fallback() {
    return (
      this.element.getAttribute('href') || this.data.get('fallback') || '/'
    );
  }

  go(event) {
    event.preventDefault();

    if (this._canGoBackToSameDomain()) {
      history.back();
    } else {
      window.location.href = this.fallback;
    }
  }

  _canGoBackToSameDomain() {
    return (
      document.referrer.indexOf(location.protocol + '//' + location.host) === 0
    );
  }
}
